import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import AppContext from '../../../contexts/AppContext';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  snackBar: {
    zIndex: 1400,
  },
  paper: {
    borderRadius: '10px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    maxWidth: '700px',

    color: 'black',
    outline: 'none',
  },
  locationLink: {
    color: 'white',
  },
  video: {
    marginBottom: theme.spacing(2),
  },
  startBtn: {
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
});

class ConfirmQuitModal extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidUpdate(prevProps, prevState) {}

  render() {
    const { classes } = this.props;
    const { dictionnary } = this.context;

    return (
      <>
        <ClickAwayListener
          onClickAway={() => {
            if (this.props.onCloseHandler) {
              this.props.onCloseHandler();
            }
          }}
        >
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={this.state.open}
            onClose={() => {
              if (this.props.onCloseHandler) {
                this.props.onCloseHandler();
              }
            }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            disableEnforceFocus
            disableAutoFocus
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={this.state.open}>
              <div className={classes.paper}>
                <h2 id="transition-modal-title">
                  {dictionnary.get('leave-title')}
                </h2>
                <p id="transition-modal-description">
                  {dictionnary.get('leave-descr')}
                </p>

                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.startBtn}
                  onClick={() => {
                    if (this.props.onConfirmationHandler) {
                      this.props.onConfirmationHandler();
                    }
                  }}
                >
                  {' '}
                  &nbsp; {dictionnary.get('common-leave-gallery')}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.startBtn}
                  onClick={() => {
                    if (this.props.onCancelHandler) {
                      this.props.onCancelHandler();
                    }
                  }}
                >
                  {' '}
                  &nbsp; {dictionnary.get('common-return-gallery')}
                </Button>
              </div>
            </Fade>
          </Modal>
        </ClickAwayListener>
      </>
    );
  }
}

export default withStyles(styles)(ConfirmQuitModal);
